/**
 * Utility functions for consistent image handling across the application
 */

export class ImageUtils {
  /**
   * Get the best available app icon with fallback chain
   * Priority: androidImageUrl -> icon -> default placeholder
   */
  static getAppIcon(app: any): string {
    if (app.androidImageUrl && app.androidImageUrl.trim()) {
      return app.androidImageUrl.trim();
    }
    
    if (app.icon && app.icon.trim()) {
      return app.icon.trim();
    }
    
    return '/assets/images/app-placeholder.png';
  }

  /**
   * Handle image loading errors with fallback to default placeholder
   */
  static handleImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    if (target && target.src !== '/assets/images/app-placeholder.png') {
      target.src = '/assets/images/app-placeholder.png';
    }
  }

  /**
   * Get category icon with fallback
   */
  static getCategoryIcon(category: any): string {
    if (category?.iconPath && category.iconPath.trim()) {
      return category.iconPath.trim();
    }
    
    return '/assets/images/default-category.png';
  }
}